/* ============================================================
   RR Global JS
   - Smart header: hide on scroll down, reveal on scroll up
   - Safari viewport height fix (--rr-vh)
   ============================================================ */

/* ── Overflow Diagnostic ──────────────────────────────────── */
/* Finds elements wider than the viewport and logs them.
   Add ?rr-debug to any URL to also see a visible banner.      */
(function () {
  function rrFindOverflow() {
    var vw = document.documentElement.clientWidth;
    var scrollW = document.documentElement.scrollWidth;
    var found = [];
    document.querySelectorAll('*').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.right > vw + 2) {
        var cls = typeof el.className === 'string' ? el.className.slice(0, 80) : '';
        var pos = window.getComputedStyle(el).position;
        /* Fixed-Position Elemente (Cart Drawer off-screen) überspringen —
           sie verursachen keinen echten Scroll und sind kein Layout-Problem */
        if (pos === 'fixed') return;
        found.push({
          tag: el.tagName,
          id: el.id || '',
          cls: cls,
          over: Math.round(r.right - vw),
          pos: pos
        });
      }
    });

    if (found.length) {
      console.group('[RR] Horizontal overflow elements (' + found.length + '): scrollW=' + scrollW + ' vw=' + vw);
      found.forEach(function (o) {
        console.log('+' + o.over + 'px [' + o.pos + ']  <' + o.tag + (o.id ? '#' + o.id : '') + '>  ' + o.cls);
      });
      console.groupEnd();
    } else {
      console.log('[RR] No horizontal overflow detected (viewport: ' + vw + 'px, scrollW: ' + scrollW + 'px)');
    }

    /* Debug-Banner nur mit ?rr-debug in der URL */
    if (found.length && window.location.search.indexOf('rr-debug') !== -1) {
      var banner = document.createElement('div');
      banner.style.cssText = [
        'position:fixed', 'top:0', 'left:0', 'right:0', 'z-index:999999',
        'background:#c00', 'color:#fff', 'font:12px/1.4 monospace',
        'padding:8px 12px', 'max-height:40vh', 'overflow-y:auto',
        'box-shadow:0 2px 8px rgba(0,0,0,.5)', 'pointer-events:auto'
      ].join(';');
      banner.innerHTML = '<strong>[RR Overflow Debug] scrollW=' + scrollW + ' vw=' + vw + '</strong><br>' +
        found.slice(0, 8).map(function (o) {
          return '+' + o.over + 'px [' + o.pos + '] &lt;' + o.tag + (o.id ? '#' + o.id : '') + '&gt; ' +
            o.cls.replace(/</g, '&lt;').replace(/>/g, '&gt;');
        }).join('<br>');
      document.body.appendChild(banner);
    }

    return found;
  }

  /* Run after page fully loaded — catches late-loading scripts */
  window.addEventListener('load', function () {
    setTimeout(rrFindOverflow, 300);
  });
})();

/* ── Premium Mobile Nav Drawer Styling ────────────────────── */
(function () {
  if (window.innerWidth > 989) return;

  // Hover/active CSS (pseudo-classes via stylesheet, not inline)
  var hoverCSS = document.createElement('style');
  hoverCSS.textContent =
    '.rr-nav-li { transition: background 0.15s ease !important; }' +
    '.rr-nav-li:hover, .rr-nav-li:active { background: rgba(25,23,24,0.05) !important; }';
  document.head.appendChild(hoverCSS);

  function styleDrawer() {
    var drawer = document.querySelector('header-drawer .js-drawer');
    if (!drawer) return;

    // ── <li> als flex row: Pfeil + Text auf gleicher Höhe ─────
    var listItems = drawer.querySelectorAll('li');
    listItems.forEach(function (li, i) {
      li.classList.add('rr-nav-li');
      li.style.setProperty('display', 'flex', 'important');
      li.style.setProperty('align-items', 'center', 'important');
      li.style.setProperty('border-bottom', '1px solid rgba(25,23,24,0.10)', 'important');
      li.style.setProperty('margin', '0', 'important');
      li.style.setProperty('padding', '0', 'important');
      li.style.setProperty('list-style', 'none', 'important');
      li.style.setProperty('cursor', 'pointer', 'important');
      if (i === 0) li.style.setProperty('border-top', '1px solid rgba(25,23,24,0.10)', 'important');

      // Touch-Feedback (ergänzend zu CSS hover)
      li.addEventListener('touchstart', function () {
        li.style.setProperty('background', 'rgba(25,23,24,0.06)', 'important');
      }, { passive: true });
      li.addEventListener('touchend', function () {
        setTimeout(function () {
          li.style.setProperty('background', 'transparent', 'important');
        }, 200);
      });
    });

    // ── <a> Links: uppercase, flex-grow (Pfeil bleibt rechts) ─
    var links = drawer.querySelectorAll('li > a, .drawer__menu-item a');
    links.forEach(function (a) {
      a.style.setProperty('flex', '1 1 auto', 'important');
      a.style.setProperty('text-transform', 'uppercase', 'important');
      a.style.setProperty('letter-spacing', '0.14em', 'important');
      a.style.setProperty('font-weight', '700', 'important');
      a.style.setProperty('font-size', '11px', 'important');
      a.style.setProperty('padding', '18px 28px', 'important');
      a.style.setProperty('display', 'block', 'important');
      a.style.setProperty('color', '#191718', 'important');
      a.style.setProperty('text-decoration', 'none', 'important');
    });

    // ── Pfeil-/Icon-Geschwister: zentriert + rechts-Padding ───
    // Matcht: button, span, svg — alles außer a, ul, ol, div, details, summary
    var arrowEls = drawer.querySelectorAll(
      'li > button, li > span:not([class*="text"]), li > .icon, li > [class*="arrow"], li > [class*="caret"], li > [class*="toggle"]'
    );
    // Fallback: breiter Selektor wenn obige nichts finden
    if (arrowEls.length === 0) {
      arrowEls = drawer.querySelectorAll('li > *:not(a):not(ul):not(ol):not(div):not(details):not(summary)');
    }
    arrowEls.forEach(function (el) {
      el.style.setProperty('display', 'flex', 'important');
      el.style.setProperty('align-items', 'center', 'important');
      el.style.setProperty('justify-content', 'center', 'important');
      el.style.setProperty('align-self', 'center', 'important');  /* vertikale Zentrierung im li */
      el.style.setProperty('padding-right', '28px', 'important');
      el.style.setProperty('flex-shrink', '0', 'important');
      el.style.setProperty('color', '#191718', 'important');
      el.style.setProperty('position', 'relative', 'important'); /* kein absolute-Override */
      el.style.setProperty('height', 'auto', 'important');
    });
  }

  document.addEventListener('DOMContentLoaded', styleDrawer);
  document.addEventListener('click', function (e) {
    if (e.target.closest('.drawer__button, .header__icon--menu, summary')) {
      setTimeout(styleDrawer, 80);
    }
  });
})();

/* ── Post-Load Overflow-Fix ───────────────────────────────── */
/* Debug (echtes iPhone vw=402): scrollW=512, +110px im Header-Container.
   Ursache: --page-gutter zu groß. Fix: Variable + Container-Padding direkt. */
(function () {
  function fixOverflow() {
    if (window.innerWidth > 989) return;

    /* ── CSS-Variable überschreiben (Inline !important = höchste Prio) */
    document.documentElement.style.setProperty('--page-gutter', '20px', 'important');
    document.documentElement.style.setProperty('--page-gutter-mobile', '20px', 'important');

    /* ── Container: ALLE Padding-Properties gleichzeitig ─────────
       Shorthand + logical + longhand — keine Lücke für Section-CSS */
    document.querySelectorAll('.container').forEach(function (c) {
      c.style.setProperty('padding-inline', '20px', 'important');
      c.style.setProperty('padding-left', '20px', 'important');
      c.style.setProperty('padding-right', '20px', 'important');
      c.style.setProperty('box-sizing', 'border-box', 'important');
      c.style.setProperty('width', '100%', 'important');
      c.style.setProperty('max-width', '100%', 'important');
    });

    /* ── Cart Drawer position:fixed ────────────────────────────── */
    document.querySelectorAll('.cart-drawer_inner, .cart-drawer__inner').forEach(function (el) {
      el.style.setProperty('position', 'fixed', 'important');
    });
  }

  document.addEventListener('DOMContentLoaded', fixOverflow);
  window.addEventListener('load', fixOverflow);
  window.addEventListener('load', function () { setTimeout(fixOverflow, 200); });
  window.addEventListener('load', function () { setTimeout(fixOverflow, 600); });
  window.addEventListener('load', function () { setTimeout(fixOverflow, 1500); });
})();

/* ── Safari Viewport Height Fix ───────────────────────────── */
(function () {
  /* window.innerHeight ist in Safari die echte sichtbare Höhe
     (ohne URL-Bar / Tab-Bar) — zuverlässiger als 100vh oder svh.
     Wir setzen --rr-vh als CSS Custom Property auf <html>. */
  function setVH() {
    document.documentElement.style.setProperty('--rr-vh', (window.innerHeight * 0.01) + 'px');
  }
  setVH();
  window.addEventListener('resize', setVH);
  window.addEventListener('orientationchange', function () {
    setTimeout(setVH, 150);
  });
})();
(function () {
  'use strict';

  /* ── Smart Header ─────────────────────────────────────────── */
  var header = document.querySelector('.shopify-section-group-header-group');
  if (!header) return;

  // Initialise from actual scroll position so iOS scroll-restoration
  // doesn't immediately hide the header on first scroll event.
  var lastScrollY  = window.scrollY || window.pageYOffset;
  var ticking      = false;
  var HIDE_AFTER   = 80; // px scrolled before we start hiding

  function onScroll() {
    var currentY = window.scrollY || window.pageYOffset;

    if (currentY > lastScrollY && currentY > HIDE_AFTER) {
      // Scrolling DOWN → hide header
      header.classList.add('rr-header-hidden');
    } else {
      // Scrolling UP or near top → show header
      header.classList.remove('rr-header-hidden');
    }

    lastScrollY = currentY;
    ticking     = false;
  }

  // Also ensure header is visible on page load (in case of cached state)
  window.addEventListener('load', function () {
    var currentY = window.scrollY || window.pageYOffset;
    if (currentY <= HIDE_AFTER) {
      header.classList.remove('rr-header-hidden');
    }
    lastScrollY = currentY;
  });

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(onScroll);
      ticking = true;
    }
  }, { passive: true });

})();
